import {EventFunc} from "types/types";
import * as React from "react";
import {NavLinkInfoPill} from "components/nav/NavLinkInfoPill";
import {UIState} from "data/UIState";
import {PageEnum} from "components/nav/PageEnums";



export const NavLink = (props:Props) => {

  if(props.hide) {
    return null;
  }

  let onClick:EventFunc = ()=>{};
  let text = '';
  let selected = props.selected;
  const pageEnum = props.pageEnum;
  if(pageEnum) {
    selected = UIState.currentPage.is(pageEnum);
    onClick = () => {
      UIState.currentPage = pageEnum;
    }
    text = pageEnum.title;
  }

  // override PageEnum
  if(props.text) {
    text = props.text;
  }
  if(props.onClick) {
    onClick = props.onClick;
  }

  return (
    <li>
    <div
      tabIndex={0}
      role="button"
      className={`link${selected ? ' selected' : ''}${props.small ? ' sm' : ''}`}
      onClick={onClick}
    >
      <div className={`text${props.small ? ' sm' : ''}`}>
        {props.avatar}
        {props.icon && <i aria-hidden={true} className={props.icon}></i>}
        {selected && <span className="visuallyhidden">Current Page: </span>}
        {props.hiddenReadableTextLabel && <span className="visuallyhidden">{props.hiddenReadableTextLabel }: </span> }
        {text}
        <NavLinkInfoPill value={props.infoPillValue} readable={props.infoPillReadable} pillClass={props.pillClass} style={props.pillStyle} />
      </div>
      {props.children &&
        <div className="right">
          {props.children}
        </div>
      }
    </div>
    </li>
  );
};


interface Props {
  hide?:boolean;
  icon?: string;
  avatar?: any;
  selected?: boolean;
  onClick?: EventFunc;
  pillClass?: string;
  pillStyle?: any;
  infoPillValue?: string;
  infoPillReadable?: string;
  text?: string;
  hiddenReadableTextLabel?: string;
  children?: any;
  small?: boolean;
  pageEnum?:PageEnum;
}
